export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створити звіт"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Результат валюти"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завантажити"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аркуш"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дозволений формат файлу - xlsx"])}
}